import { render, staticRenderFns } from "./PDNProfileTableMenu.vue?vue&type=template&id=1323c178&scoped=true&"
import script from "./PDNProfileTableMenu.vue?vue&type=script&lang=js&"
export * from "./PDNProfileTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323c178",
  null
  
)

export default component.exports